import { InsurerStatus } from '@/@types/generated'
import { VariantProps } from 'class-variance-authority'
import { badgeVariants } from '@/components/ui/badge'
import { register } from './enum'

type BadgeVariant = VariantProps<typeof badgeVariants>['variant']

export const InsurerStatusLabels: Record<InsurerStatus, string> = {
  [InsurerStatus.AC]: 'Active',
  [InsurerStatus.IN]: 'Inactive',
}

export const InsurerStatusVariants: Record<InsurerStatus, BadgeVariant> = {
  [InsurerStatus.AC]: 'default',
  [InsurerStatus.IN]: 'secondary',
}

register<InsurerStatus>(InsurerStatus, (v) => {
  if (!v) return '—'
  return InsurerStatusLabels[v]
})
